<style scoped lang="scss" type="text/scss">
    /*必须写在最外层*/
    .search-box {
        width: 100%;
    }
</style>

<template>
    <el-select
            class="search-box"
            v-model="valueSync"
            multiple
            :multiple-limit="multipleLimit"
            filterable
            remote
            clearable
            :placeholder="placeholder"
            :remote-method="remoteMethod"
            :loading="loading"
            @visible-change="visibleChange"
            @clear="sync"
    >
        <el-option
                v-for="item in candidates"
                :key="item.id"
                :label="`${item.personal_name}（ ${item.school_name} ）`"
                :value="item.id">
            <span style="float: left">{{ item.personal_name }}（ {{ item.school_name }} ）</span>
            <span class="global-text-ellipsis"
                  style="float: right; color: #8492a6; font-size: 13px; margin-right: 1.5rem; max-width: 20rem;">
                {{ item.type_text }}（ {{ item.team_name }} ）
            </span>
        </el-option>
    </el-select>
</template>

<script>
    import {handlePlayerMembers} from '../../../utils/data-handler';

    export default {
        name: '',
        props: {
            value: Array,
            multipleLimit: Number,
            placeholder: {
                type: String,
                default: '输入姓名（ 全名 ）以搜索该届比赛的参赛人员'
            }
        },
        data () {
            return {
                valueSync: [],
                loading: false,
                candidates: []
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            }
        },
        watch: {
            value (value) {
                this.valueSync = value;
                if (value === null || value === undefined) value = [];
                if (value.length > 0) {
                    this.$store.dispatch('player/loadMembersByMemberIds', {
                        player_members: value.join(',')
                    }).then(response => {
                        this.candidates = handlePlayerMembers(response.data);
                    });
                } else {
                    this.candidates = [];
                    this.valueSync = [];
                }
            },
            valueSync (valueSync) {
                if (valueSync === '') {
                    this.valueSync = [];
                }
            }
        },
        methods: {
            visibleChange (visible) {
                if (!visible) {
                    this.sync();
                }
            },
            sync () {
                this.$emit('input', this.valueSync);
            },
            remoteMethod (query) {
                if (query !== '') {
                    this.loading = true;
                    this.$normalRequest('player/searchMembersByCompetitionIdAndPersonalName', {
                        competition_id: this.currentCompetitionId,
                        name: query
                    }).then(data => {
                        this.loading = false;
                        this.candidates = handlePlayerMembers(data);
                    }).catch(_ => {
                        this.loading = false;
                        this.candidates = [];
                    });
                } else {
                    this.candidates = [];
                }
            }
        }
    };
</script>
